import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import Checkbox from '@afosto/app-components-react/Checkbox';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import TextField from '@afosto/app-components-react/TextField';
import ProductSearch from '@afosto/app-components-react/ProductSearch';
import validationSchema from './validations';
import translations from './translations';

const SkuPositionForm = ({ onCancel, onSubmit }) => {
  const intl = useIntl();
  const positionRef = useRef(null);
  const productRef = useRef(null);

  const form = useForm({
    validationSchema,
    defaultValues: {
      product: '',
      sku: '',
      position: '',
      addAnotherProduct: true,
    },
    clearOnSubmit: true,
    onSubmit: async data => {
      try {
        if (onSubmit) {
          await onSubmit({ ...data, position: data?.position?.toUpperCase() });
        }

        if (data.addAnotherProduct) {
          productRef.current.focus();
        }

        return null;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    onCancel,
  });
  const { setValue } = form;

  const handleProductChange = (ev, newValue) => {
    setValue('product', newValue);

    if (newValue?.sku) {
      setValue('sku', newValue.sku);

      if (positionRef.current) {
        positionRef.current.focus();
      }
    } else {
      setValue('sku', '');
    }
  };

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <ProductSearch
          name="product"
          label={intl.formatMessage(translations.fields.product.label)}
          onChange={handleProductChange}
          inputRef={productRef}
        />

        <TextField name="sku" label={intl.formatMessage(translations.fields.sku.label)} />

        <TextField
          name="position"
          label={intl.formatMessage(translations.fields.position.label)}
          inputRef={positionRef}
        />

        <Checkbox
          name="addAnotherProduct"
          label={intl.formatMessage(translations.fields.addAnotherProduct.label)}
        />
      </Form>
    </LoadingWrapper>
  );
};

SkuPositionForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

SkuPositionForm.defaultProps = {
  onCancel: undefined,
  onSubmit: undefined,
};

export default SkuPositionForm;
